import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';

export const SymbolLabel: FC<IProps> = ({
    BaseHeading,
    children,
    headingSize = 5,
    styles = {},
    symbol = '₽',
}) => {
    return (
        <BaseHeading
            className={cn(styles.external, styles.label)}
            marginBottom={null}
            marginTop={false}
            size={headingSize}
            theme="white"
        >
            {children}&nbsp;{symbol}
        </BaseHeading>
    );
};
